const items = [
    "ATENDIMENTO PERSONALIZADO",
    "QUALIDADE",
    "EXPERIÊNCIA",
    "SUPORTE",
];

export default function TrustBar() {
    return (
        <section
            data-testid="trust-bar"
            aria-label="Nossos compromissos"
            className="overflow-hidden border-y border-line bg-cream py-5"
        >
            <div className="flex w-max animate-marquee">
                {[0, 1].map((copy) => (
                    <div
                        key={copy}
                        aria-hidden={copy === 1}
                        className="flex items-center"
                    >
                        {items.map((item) => (
                            <span
                                key={`${copy}-${item}`}
                                className="flex items-center gap-8 pr-8 font-mono text-[10px] uppercase tracking-[0.3em] text-ink-soft sm:text-xs"
                            >
                                {item}
                                <span className="text-accent">◆</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </section>
    );
}
